import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  CheckCircleOutlined, CloseCircleOutlined,
} from '@ant-design/icons';
import {
  Input, Spin, Form,
} from 'antd';
import './MatriculationHandle.scss';
import { SessionExpiredException } from '../../utils/errors';
import { checkMatriculation } from '../../utils/sapUtils';
import { RequestWrapper } from '../../dataSource/requests';

const MatriculationHandle = (props): JSX.Element => {
  const {
    matriculationArray,
    initalStatus,
  } = props;
  const [validating, setValidating] = useState([]);
  const [, setForceRerender] = useState<number>(1);
  const [, setState] = useState<boolean>(true);

  useEffect(() => {
    return () => {
      setState(false);
    };
  }, []);

  const getItemIcon = (statuss): JSX.Element | null => {
    let icon;

    switch (statuss) {
      case 'success':
        icon = <CheckCircleOutlined style={{ color: 'green' }} />;
        break;

      case 'error':
        icon = <CloseCircleOutlined style={{ color: 'red' }} />;
        break;

      default:
        icon = null;
        break;
    }

    return icon;
  };

  const validateMatriculation = async (matriculationArrayP, value, index): Promise<void> => {
    const { handleMATRICULA } = props;

    const auxiliarArray = matriculationArrayP;
    const aux = validating;

    if (value.length === 10) {
      let result;

      try {
        const requestRef: RequestWrapper = checkMatriculation(value);
        result = await requestRef;
      } catch (error) {
        if (!(error instanceof SessionExpiredException)) {
          auxiliarArray[index].error = true;
          auxiliarArray[index].errorMessage = 'Ocorreu um erro ao validar a matrícula';
          auxiliarArray[index].status = 'error';
          aux[index] = false;

          setValidating(aux);
          handleMATRICULA(auxiliarArray);
          setForceRerender((previous) => previous + 1);
        }

        return;
      }
      if (result.body.MT_VALIDAMATRICULA_Resp.ROWS.CODRETORNO === -1) {
        auxiliarArray[index].error = true;
        auxiliarArray[index].errorMessage = 'Matrícula não encontrada. Verifique e tente novamente.';
        auxiliarArray[index].status = 'error';
        aux[index] = false;

        setValidating(aux);
        handleMATRICULA(auxiliarArray);
        setForceRerender((previous) => previous + 1);
      }

      if (result.body.MT_VALIDAMATRICULA_Resp.ROWS.CODRETORNO === 1) {
        auxiliarArray[index].error = false;
        auxiliarArray[index].errorMessage = '';
        auxiliarArray[index].status = 'success';
        aux[index] = false;
        setValidating(aux);
        handleMATRICULA(auxiliarArray);
        setForceRerender((previous) => previous + 1);
      }
    }
  };

  const checkEquals = (id, index): void => {
    const { matriculationArray: matriculationArrayP, handleMATRICULA } = props;

    matriculationArrayP[index].equalsId = [];

    matriculationArrayP.forEach((m, index2) => {
      if (m.equalsId.includes(id)) {
        if (m.equalsId.length === 2) {
          matriculationArrayP[index2].equalsId = [];

          validateMatriculation(matriculationArrayP, m.value, index2);
        } else {
          matriculationArrayP[index2].equalsId = matriculationArrayP[index2]
            .equalsId.filter((maID) => maID !== id);
        }
      }
    });

    handleMATRICULA(matriculationArrayP);
  };

  const changeValue = (index, text, id): void => {
    const { matriculationArray: matriculationArrayP, handleMATRICULA } = props;

    const newMatriculationArray = [...matriculationArrayP];

    newMatriculationArray[index].value = text;
    const aux = validating;

    checkEquals(id, index);

    if (text.length === 10) {
      aux[index] = true;

      setValidating(aux);

      matriculationArrayP.forEach((m, index2) => {
        if (index2 !== index) {
          if (m.value === text) {
            newMatriculationArray[index].error = true;
            newMatriculationArray[index].errorMessage = 'Matricula já inserida';
            newMatriculationArray[index].status = 'error';
            aux[index] = false;

            setValidating(aux);

            newMatriculationArray[index].equalsId.push(matriculationArrayP[index2].id);
            newMatriculationArray[index].equalsId.push(id);
            newMatriculationArray[index]
              .equalsId = [...new Set(newMatriculationArray[index].equalsId)];

            handleMATRICULA(newMatriculationArray);
          }
        }
      });

      if (newMatriculationArray[index].error) return;

      validateMatriculation(newMatriculationArray, text, index);
    } else {
      newMatriculationArray[index].error = false;
      newMatriculationArray[index].errorMessage = '';
      newMatriculationArray[index].status = '';
    }

    handleMATRICULA(newMatriculationArray);
  };

  const removeMatriculation = (item, index): void => {
    const { matriculationArray: matriculationArrayP, handleMATRICULA } = props;

    const aux = validating;
    const newMatriculationArray = matriculationArrayP.filter((matricula) => item !== matricula);

    aux[index] = false;

    setValidating(aux);

    newMatriculationArray.forEach((m, index2) => {
      if (m.equalsId.includes(item.id)) {
        if (m.equalsId.length === 2) {
          newMatriculationArray[index2].equalsId = [];

          validateMatriculation(newMatriculationArray, m.value, index2);
        } else {
          newMatriculationArray[index2].equalsId = newMatriculationArray[index2]
            .equalsId.filter((maID) => maID !== item.id);
        }
      }
    });

    handleMATRICULA(newMatriculationArray);
  };

  const addMatriculation = (): void => {
    const { matriculationArray: matriculationArrayP, handleMATRICULA } = props;
    const newMatriculationArray = [
      ...matriculationArrayP,
      {
        id: matriculationArrayP[matriculationArrayP.length - 1].id + 1,
        value: '',
        error: false,
        status: '',
        errorMessage: '',
        equalsId: [],
        back: false,
      },
    ];

    handleMATRICULA(newMatriculationArray);
  };

  const formItems = matriculationArray.map((item, index) => (
    <div key={`matriculationContainer${index}`} className="matriculation-container">
      <div className="matriculation-wrapper">
        <Form.Item
          key={index}
          validateStatus={item.error ? 'error' : ''}
          help={item.error && item.errorMessage}
          className="codes"
        >
          <Input
            value={item.value}
            disabled
            onChange={
              (text): void => {
                changeValue(index, text.target.value, item.id);
              }
            }
            suffix={!validating[index] ? getItemIcon(item.status) : <Spin />}
            className="input-registration"
            placeholder="Matrícula com 10 dígitos"
            maxLength={10}
          />
        </Form.Item>
        {/* <div className="dynamic-delete-button-container">
          {
            matriculationArray.length > 1
              ? (
                <Button
                  key={`deleteButton${index}`}
                  type="link"
                  className="dynamic-delete-button"
                  icon={<DeleteFilled />}
                  onClick={() => removeMatriculation(item, index)}
                  disabled
                />
              )
              : (
                <Button
                  key={`deleteButton${index}`}
                  type="link"
                  className="dynamic-delete-button"
                  icon={<DeleteOutlined />}
                  style={{ color: 'transparent', cursor: 'default' }}
                  disabled
                />
              )
          }
        </div> */}
      </div>
      {
        matriculationArray[index].status === 'success'
        && (
          <Form.Item
            key={`matriculationStatus${item.id}`}
            className="mat-forms"
            name={`matriculationsStatus[${item.id}]`}
            validateTrigger={['onBlur']}
            initialValue={
              initalStatus[item.id] || 'PENDING_APPROVAL'
            }
          >
            <div className="mat-status">
              {initalStatus[item.id] === 'ACTIVATED' ? 'Status: Aprovado' : ''}
              {initalStatus[item.id] === 'DEACTIVATED' ? 'Status: Reprovada' : ''}
              {initalStatus[item.id] === 'PENDING_APPROVAL' ? 'Status: Aprovação Pendente' : ''}
              {initalStatus[item.id] === undefined ? 'Status: Aprovação Pendente' : ''}
            </div>
          </Form.Item>
        )
      }
    </div>
  ));

  return (
    <div className="MatriculationHandle">
      {formItems}
      {/* <Form.Item className="add-matriculation-form">
        <Button
          type="dashed"
          onClick={addMatriculation}
          ghost
          className="add-matriculation-button"
          disabled
        >
          ADICIONAR MATRÍCULA
        </Button>
      </Form.Item> */}
    </div>
  );
};

MatriculationHandle.propTypes = {
  initalStatus: PropTypes.objectOf(PropTypes.any),
  handleMATRICULA: PropTypes.func.isRequired,

  matriculationArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string,
    error: PropTypes.bool,
    status: PropTypes.string,
    errorMessage: PropTypes.string,
    equalsId: PropTypes.arrayOf(PropTypes.any),
  })).isRequired,
};

MatriculationHandle.defaultProps = {
  initalStatus: {},
};

export default MatriculationHandle;
